import React, { Component } from 'react';
import {StyleSheet, Dimensions, View, Platform} from 'react-native'
import { JDDevice, JDTouchable, JDViewPager, JDText, JDImage, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'

import Swiper from '../../../../components/thirdScript/RNSwiper';
import WebSwiper from './WebSwiper'
import appStyles from '../../../../App.style';

const {width, height} = Dimensions.get('window');

export default class BigImgSwiper extends Component {
	static propTypes = {
		imgSwiperData: PropTypes.array,
		imgDomainIndex: PropTypes.number,
		currentPage: PropTypes.number
	};
	constructor (props) {
		super(props);
		this.state = {
			currentPage: this.props.currentImgPage || 0
		}
	}
	_renderPage = (imgUrl,index) => {
		return (
				<JDTouchableWithoutFeedback
						style={styles.touch}
						key={"bigSwiper_"+index}
						onPress={this._clickPreview}>
					<JDImage style={styles.image} source={{uri: imgUrl}} />
				</JDTouchableWithoutFeedback>
		)
	};
	_pageChange = (pageNumber) => {
		this.setState({
			currentPage: pageNumber
		})
	};
	_clickPreview = () => {
		this.props.quitImgPreview();
	};
	render() {
		const {currentPage} = this.state;
		const {imgSwiperData} = this.props;
		const totalPage = imgSwiperData.length;
		if (Platform.OS == 'android' || Platform.OS == 'ios') {
			return (
					<View style={styles.viewContainer}>
						<JDTouchableWithoutFeedback onPress={this._clickPreview}>
							<View style={styles.viewTouch}>
								{
									imgSwiperData.length > 1 && (
											<View style={styles.textWrap}>
												<JDText style={styles.text}>{currentPage+1} / {totalPage}</JDText>
											</View>
									)
								}
								<View style={styles.swiperWrap}>
									<Swiper
											height={JDDevice.getRpx(600)}
											index={currentPage}
											style={styles.bannerWrapper}
											loop={false}
											onIndexChanged={this._pageChange}
											showsPagination={false}
									>
										{
											imgSwiperData.map((item, index) => {
												return (
														this._renderPage(item, index)
												)
											})
										}
									</Swiper>
								</View>
							</View>
						</JDTouchableWithoutFeedback>
					</View>
			)
		} else {
			return (
					<View style={styles.viewContainer}>
						<WebSwiper
								imgSwiperData={imgSwiperData}
								currentPage={currentPage}
								imgWrapperWebStyle={styles.imgWrapperWebStyle}
								imgWebStyle={styles.imgWebStyle}
								indicatorWebStyle={styles.indicatorWeb}
								toClickHouseImg={this._clickPreview}
						></WebSwiper>
					</View>
			)
		}
	}
}
const styles = StyleSheet.create({
	viewContainer: {
		backgroundColor: '#fff',
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 9999,
		overflow: 'hidden' // 防止大图滚动
	},
	viewTouch: {
		justifyContent: 'center',
		height: JDDevice.height-90,
		...Platform.select({                //不同的平台执行不同的样式
			web: {
				height: JDDevice.height
			}
		})
	},
	textWrap: {
		position: 'absolute',
		alignItems: 'center',
		top: JDDevice.getRpx(100),
		width: width,
		paddingBottom:  JDDevice.getRpx(60),
		...Platform.select({                //不同的平台执行不同的样式
			web: {
				top: JDDevice.getRpx(150)
			}
		})
	},
	text: {
		fontSize: JDDevice.getRpx(28)
	},
	swiperWrap: {
		height: JDDevice.getRpx(800),
	},
	touch: {
		flex: 1
	},
	image: {
		width: JDDevice.width,
		height: JDDevice.getRpx(800),
		resizeMode: 'contain'
	},
	//	web端轮播图的样式
	imgWrapperWebStyle: {
		display: 'flex',
		alignItems: 'center',
		width: width,
		height: height,
		backgroundColor: '#fff'
	},
	imgWebStyle: {
		width,
		height: JDDevice.getRpx(800),
		resizeMode: 'contain',
		backgroundColor: '#f4f4f4'
	},
	indicatorWeb: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		top: (height-JDDevice.getRpx(800))/4,
		height: JDDevice.getRpx(42),
		color:'#000'
	}
});